import { css, type FC } from "dreamland/core";
import type { Tab } from "../Tab/Tab";
import { iconLink, iconClose, iconFolder } from "../icons";
import { Icon } from "@components/Icon";
import { formatBytes } from "../util";
import { Favicon } from "@components/Favicon";
import { downloadsService, tabsService } from "..";

export function DownloadsPage(this: FC<{ tab: Tab }>) {
	return (
		<div>
			<nav>
				<h1>Downloads</h1>
			</nav>
			<ul class="entries">
				{use(downloadsService.globalDownloadHistory).mapEach((entry) => {
					const url = new URL(entry.url);
					return (
						<li
							class="entry"
							on:click={() => {
								tabsService.newTab(url);
							}}
						>
							<span class="inner">
								<Favicon domain={url.hostname} size="medium"></Favicon>
								<div class="text">
									<span class="title">{entry.filename}</span>
									<span class="url">{url.hostname}</span>
									<div class="details">
										<span>{formatBytes(entry.size)}</span>
										<span>{new Date(entry.timestamp).toDateString()}</span>
									</div>
								</div>
								<div class="icons">
									<Icon icon={iconFolder}></Icon>
									<Icon icon={iconLink}></Icon>
									<Icon icon={iconClose}></Icon>
								</div>
							</span>
						</li>
					);
				})}
			</ul>
		</div>
	);
}
DownloadsPage.style = css`
	:scope {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		background: var(--ntp_background);
		color: var(--ntp_text);
	}
	nav {
		width: 100%;
		padding: var(--space-xxl);
		background: var(--toolbar);
	}
	h1 {
		font-size: 1.5rem;
		font-weight: 600;
		margin-left: 0;
	}
	.entries {
		list-style: none;
		padding: 0;
		margin: 0;
		width: 100%;
		padding-right: 1.75em;
	}
	.entry {
		width: 100%;
		transition: background 0.1s;
	}
	.inner {
		display: flex;
		align-items: center;
		gap: var(--space-md);
		cursor: pointer;
		padding-block: var(--space-lg);
		padding-left: var(--space-md);
		margin-left: 1.75em;
		border-bottom: 1px solid var(--ntp-text-10);
	}
	.entry:hover {
		background: var(--ntp-text-10);
	}
	.entry img {
		width: 16px;
		height: 16px;
	}
	.entry .title {
		font-weight: bold;
		color: inherit;
		text-decoration: none;
	}
	.entry .title:hover {
		color: var(--tab_line);
		text-decoration: underline;
	}
	.inner span {
		white-space: nowrap;
		overflow: hidden;
		padding: 0.085em;
		text-overflow: ellipsis;
	}
	.text {
		display: flex;
		flex-direction: column;
		gap: var(--space-xs);
		flex: 1;
		min-width: 0;
	}
	.details {
		display: flex;
		gap: 1em;
		color: var(--ntp-text-70);
	}
	.icons {
		display: flex;
		gap: var(--space-md);
		margin-left: 0.75em;
	}
	.icons :global(svg) {
		width: 1em;
		height: 1em;
		color: var(--ntp-text-70);
	}
`;
